import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { Button } from "reactstrap";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../pages/Cookie/GetCookie";

import { useLayOutConText } from "../../pages/Context/LayOutContext";
import { CheckPosition } from "../../pages/Function/CheckPosition";
import { CheckSubAdmin } from "../../pages/Function/CheckSubAdmin";
import { CheckBudgetYear } from "../../pages/Function/CheckBudgetYear";
import FadeIn from "react-fade-in/lib/FadeIn";

const SidebarContent = (props) => {
  const { numApprove ,setNumApprove } = useLayOutConText();

  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData")
  const user_id = user?.user_id

  const [userInfo, setUserInfo] = useState([]);
  const getUserInfo = async () => {
    try {
      const res = await axios.get(baseURL + "/api/users/info", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserInfo(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getUserInfo();
  }, []);

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      // if (pathName === items[i].pathname) {
      //   matchingMenuItem = items[i];
      //   break;
      // }
      if (pathName.includes(items[i].pathname)) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const [numberApprove, setNumberApprove] = useState()
  const getLeaveDataTable = async (
    ) => {
      try {
        const url = baseURL + `/api/leave/datatable`;
        const params = new URLSearchParams({
          page: 1,
          size: 100000,
          "order[0]": "created_date",
          "order[1]": "DESC",
          // "filter[user_id][0]": user_id,
          "filter[budget_year][0]": CheckBudgetYear() || undefined,
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        await getApproveDataTable(res?.data?.result)
      } catch (err) {
        console.error(err);
      }
    };

  const getApproveDataTable = async (responLeave) => {
    try {
      const url = baseURL + `/api/leave/approve/datatable`;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: 1,
          size: 10000,
          "order[0]": "created_date",
          "order[1]": "DESC",
          "filter[approve_id][0]": user_id,
          "filter[approve_status][0]": "0",
          // "filter[approve_status][1]": "2",
          "filter[approve_final][0]": "0",
          "filter[budget_year][1]": CheckBudgetYear(),
        },
      };
      const res = await axios.get(url, config);
      let arrForDataApp = []
      res?.data?.result &&
        res?.data?.result?.map((item) => {
          let leaveNameFromLeaveData = responLeave?.find(
            (a) =>
              parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
              a?.leave_status !== "8"
          )?.leave_name;
          let checkAppLeaveIdNStatus = responLeave?.find(
            (a) =>
              parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
              a?.leave_status !== "8"
          )?.leave_status;
          let newOBJ = {
            ...item,
            leave_name: leaveNameFromLeaveData,
            leave_status: checkAppLeaveIdNStatus,
          };
          if (
            responLeave?.some(
              (a) =>
                parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
                a?.leave_status !== "8"
            )
          ) {
            arrForDataApp.push(newOBJ)
            // setDataApprove((prev) => [...prev, newOBJ]);
          }
        });
      setNumberApprove(arrForDataApp?.length)
      setNumApprove(arrForDataApp?.length)
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getLeaveDataTable();
  },[])

  useEffect(() => {
    if(numApprove) {
      setNumberApprove(numApprove)
    }
  },[numApprove])

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu" style={{}}>
            <li className="menu-title">{props.t("รายการ")} </li>
            <li>
              <Link to="/entrywork">
                <i className=" fas fa-user-clock"></i>
                <span>{props.t("ลงเวลาปฏิบัติราชการ")}</span>
              </Link>
            </li>
            <li>
              <Link to="/leave">
                {userInfo.length !== 0 &&
                  (CheckPosition(userInfo?.position) ||
                    CheckSubAdmin(userInfo?.positionSubAdmin)) && (numberApprove !== 0) && (

                    <div
                      style={{ position: "absolute", right: "10%", top: "10%" }}
                      className="rounded-pill bg-danger text-white text-end font-size-10"
                    >
                      <FadeIn>
                      {numberApprove}
                      </FadeIn>
                    </div>
                  )}

                <i className="fa-solid fa-house-person-leave"></i>
                <span>{props.t("การลาออนไลน์")}</span>
              </Link>
            </li>
            <li>
              <Link to="/assessment">
                <i className="fa-solid fa-ballot-check"></i>
                <span>{props.t("การประเมินผลการปฏิบัติราชการ")}</span>
              </Link>
            </li>
            <li>
              <Link to="/resorcemanagement">
                <i className="fa-solid fa-laptop-file"></i>
                <span>{props.t("ทรัพยากรออนไลน์")}</span>
              </Link>
            </li>
            {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) && 
              <li>
                <Link to="/taxanddeduct">
                  <i className="fa-solid fa-money-check-dollar"></i>
                  <span>{props.t("เอกสารภาษี")}</span>
                </Link>
              </li>}
            {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(6)) && 
              <li>
                <Link to={CheckSubAdmin(userInfo?.positionSubAdmin).includes(6) ? "/setdata/?menu=salary_file" : "/setdata"}>
                  <i className="fa-solid fa-user-pen"></i>
                  <span>{props.t("กำหนดข้อมูล")}</span>
                </Link>
              </li>}
            {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) && 
              <li>
                <Link to="/news">
                  <i className="fa-solid fa-newspaper"></i>
                  <span>{props.t("ข่าวสาร")}</span>
                </Link>
              </li>}
            <li>
              <Link to="/opdctimeline">
                <i className="fa-solid fa-calendar-days"></i>
                <span>{props.t("OPDC Timeline")}</span>
              </Link>
            </li>
            <li>
              {/* <Link to="https://eoffice.opdc.go.th/portal/home">
                <i className="fa-duotone fa-link"></i>
                <span>{props.t("E-Office")}</span>
              </Link> */}
              <a 
                href="https://eoffice.opdc.go.th/portal/home" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="fa-solid fa-desktop"></i>
                <span>{props.t("E-Office")}</span>
              </a>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
